export default {
	name: "stepFive",
	data() {
		return {
			guideList: [{
				image: 'simon_ai1.png',
				title: 'Tutorials.Step5.Nav.Title',
				desc: 'Tutorials.Step5.Nav.Desc',
			},{
				image: 'simon_ai2.png',
				title: 'Tutorials.Step5.Run.Title',
				prefix: 'Tutorials.Step5.Run.Prefix',
				suffix: 'Tutorials.Step5.Run.Suffix',
			},{
				image: 'simon_ai3.png',
				title: 'Tutorials.Step5.Results.Title',
				prefix: 'Tutorials.Step5.Results.Prefix',
				suffix: 'Tutorials.Step5.Results.Suffix',
			},{
				image: 'simon_ai4.png',
				title: 'Tutorials.Step5.Tools.Title',
				prefix: 'Tutorials.Step5.Tools.Prefix',
				suffix: 'Tutorials.Step5.Tools.Suffix',
			}],
		};
	},
};